import Logger from "@cappelendamm/logger";
import { selectCreateCustomerInput } from "../selectors/selectCreateCustomerInput.js";
import { CreateCustomer } from "../mutations/CreateCustomer.core.js";
export async function createCustomer(customerInput, { client }, idReference) {
    const reference = customerInput.phone?.trim() || idReference;
    const referenceSource = customerInput.phone ? "phone" : "importId";
    Logger.log(`Creating new customer with reference: ${reference} (source: ${referenceSource}).`);
    const sanitizeCustomer = selectCreateCustomerInput(customerInput);
    const result = await client.core.request(CreateCustomer, {
        input: {
            ...sanitizeCustomer,
        },
    });
    if (result.createCustomer.__typename !== "Customer") {
        throw new Error(`Error creating customer with reference: ${reference}. ErrorName: ${result.createCustomer.errorName}. Message: ${result.createCustomer.message}`);
    }
    Logger.log(`Completed creating customer with identifier ${result.createCustomer.identifier} (reference: ${reference}).`);
    return result.createCustomer.identifier;
}
